import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Helmet from "react-helmet";
//  import { Link } from 'react-router-dom'
import {
  fetchMenusIfNeeded,
  selectNewsDetails,
  fetchNewsDetailsIfNeeded,
  selectPlayVideo,
  SERVER_BASE_URL,
  CLIENT_BASE_URL
} from "../../actions";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";

export class NewsDetailsView extends React.Component {
  constructor(props) {
    super(props);
    // CLIENT_BASE_URL = 'http://semanticvideo.net'
    this.stopVideo = this.stopVideo.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.fbShare = this.fbShare.bind(this);
    this.clickFBShare = this.clickFBShare.bind(this);
    this.ww = 0;
    this.wh = 0;
  }

  handleResize(e) {
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
  }

  componentDidMount() {
    const { match, dispatch, selectedNewsItem } = this.props;
    dispatch(selectNewsDetails(match.params.id));
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
    dispatch(selectPlayVideo(0));
    dispatch(fetchNewsDetailsIfNeeded(selectedNewsItem));
    window.addEventListener("resize", this.handleResize);
    window.scrollTo(0, 0);
    this.handleResize();
  }

  componentWillReceiveProps(nextProps) {
    const { match, dispatch } = nextProps;
    if (match.params !== this.props.match.params) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope));
    }

    const { selectedNewsItem } = this.props;
    if (selectedNewsItem !== nextProps.selectedNewsItem) {
      dispatch(selectNewsDetails(nextProps.match.params.id));
      dispatch(fetchNewsDetailsIfNeeded(nextProps.selectedNewsItem));
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
    const { dispatch } = this.props;
    dispatch(selectNewsDetails(0));
  }

  getVodBackground(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  playVideo(movie_id) {
    // console.log('movie_id: ', movie_id)
    const { dispatch } = this.props;
    dispatch(selectPlayVideo(movie_id));
  }

  stopVideo() {
    const { dispatch } = this.props;
    document
      .querySelectorAll(".container-fluid")[0]
      .classList.remove("fit-mode");
    dispatch(selectPlayVideo(0));
  }

  fbShare(share_url, share_title, share_text, share_image) {
    const url =
      "http://www.facebook.com/sharer.php?s=100&p[url]=" +
      encodeURIComponent(share_url) +
      "&p[images][0]=" +
      encodeURIComponent(share_image) +
      "&p[title]=" +
      encodeURIComponent(share_title) +
      "&p[summary]=" +
      encodeURIComponent(share_text);

    window.open(url, "sharer", "toolbar=0,status=0,width=626,height=436");
    return false;
  }

  renderVideoIframe() {
    const { selectedPlayVideo } = this.props;
    const iframeUrl = `${SERVER_BASE_URL}/play/${selectedPlayVideo}/news`;
    if (selectedPlayVideo !== 0) {
      // console.log('vou fazer o render da iframe', selectedPlayVideo)

      if (this.ww < 900) {
        return (
          <div className="popup-video" onClick={this.stopVideo}>
            <div className="iframecontainer">
              <iframe
                ref="mainIframe"
                width="100%"
                height="100%"
                src={iframeUrl}
                frameBorder="0"
                scrolling="no"
                wmode="opaque"
                allowFullScreen
              />
            </div>
          </div>
        );
      }

      let ifrmWW = 0.5 * this.ww;
      const ovr_hh = this.refs.overlay.clientHeight;
      let popup_hh = this.wh - ovr_hh;

      if (this.ww < 640) {
        ifrmWW = this.ww;
        popup_hh = this.wh;
      }

      const ifrmHH = 0.56 * ifrmWW;
      document
        .querySelectorAll(".container-fluid")[0]
        .classList.add("fit-mode");

      // vou fazer o render da iframe
      return (
        <div
          className="popup-video"
          style={{ height: popup_hh }}
          onClick={this.stopVideo}
        >
          <div
            className="iframecontainer"
            style={{ width: ifrmWW, height: ifrmHH }}
          >
            <iframe
              ref="mainIframe"
              width="100%"
              height="100%"
              src={iframeUrl}
              frameBorder="0"
              scrolling="no"
              wmode="opaque"
              allowFullScreen
            />
          </div>
        </div>
      );
    }
  }

  renderPlayButton(id, url) {
    var clickPlayVideo = this.playVideo.bind(this, id);
    // console.log('renderPlayButton', url)
    if (url && url !== "") {
      return (
        <div className="play-btn-container">
          <div onClick={clickPlayVideo}>
            <i className="glyphicon glyphicon-play" />
          </div>
        </div>
      );
    }

    return <div />;
  }

  clickFBShare() {
    const { details } = this.props;

    const share_url = `${CLIENT_BASE_URL}/noticia/${details[0].id}`;
    const share_image = `${CLIENT_BASE_URL}${details[0].poster}`;
    // console.log(share_url)
    // console.log(share_image)
    this.fbShare(share_url, details[0].title, details[0].logline, share_image);
  }

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { menus, dispatch } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    const { details } = this.props;

    const news_detail = details.length ? details[0] : {};

    let desc = "";
    if (typeof news_detail !== "undefined" && news_detail.description) {
      desc = news_detail.description
        .replace(/<(?:.|\n)*?>/gm, "")
        .replace(/&amp;nbsp;|\n|\r/gm, "");
    }

    return (
      <div>
        <Helmet
          title={news_detail.title}
          meta={[
            { name: "description", content: desc },
            {
              property: "og:image",
              content: CLIENT_BASE_URL + news_detail.poster
            },
            { property: "og:title", content: news_detail.title },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content:
                CLIENT_BASE_URL + "/noticia/" + this.props.match.params.id
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="vod">
          <div
            className="col-md-12 no-pad text-left"
            style={{ position: "relative" }}
          >
            <p className="left-tag">{news_detail.title}</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row">
            <div
              className="col-md-12 poster"
              style={this.getVodBackground(news_detail.poster)}
            >
              <div ref="overlay" className="overlay">
                <div className="row">
                  <div className="title col-sm-6">
                    <p>{news_detail.title}</p>
                  </div>
                </div>
                <div className="row">
                  <div className="summary col-sm-6">
                    <p>{news_detail.summary}</p>
                  </div>
                </div>
              </div>
              {this.renderPlayButton(news_detail.id, news_detail.video_url)}
              {this.renderVideoIframe()}
            </div>
          </div>

          <div className="row description">
            <div className="col-sm-10">
              <div className="share">
                <p>PARTILHA</p>
                <button className="share-fb-btn" onClick={this.clickFBShare} />
                <button className="share-twitter-btn" />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-5">
                <div
                  className="desc"
                  dangerouslySetInnerHTML={{ __html: news_detail.description }}
                />
              </div>
            </div>
          </div>
          <FooterLinks bottom_menus={bottom_menus} />
          <FooterNote />
        </div>
      </div>
    );
  }
}

NewsDetailsView.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  selectedNewsItem: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  selectedPlayVideo: PropTypes.number.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const {
    getMenus,
    selectedNewsItem,
    getNewsDetails,
    selectedPlayVideo,
    selectedScope
  } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingNDetail, items: details } = getNewsDetails[
    selectedNewsItem
  ] || {
    isFetchingNDetail: true,
    items: []
  };

  typeof selectedPlayVideo === "undefined" ? 0 : selectedPlayVideo;

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingNDetail,
    details,
    selectedNewsItem,
    selectedPlayVideo,
    selectedScope
  };
}

export default connect(mapStateToProps)(NewsDetailsView);



// WEBPACK FOOTER //
// ./src/views/VodView/NewsDetailsView.js